import { useCallback, useMemo, useState } from "react";

/** Backs the "Selection Mode" batch-operations UI: checkbox column,
 * select all/none, and a live count for the confirmation dialog. */
export function useSelection() {
  const [selectedIds, setSelectedIds] = useState(new Set());

  const toggle = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback(
    (allIds) => {
      setSelectedIds((prev) => (prev.size === allIds.length ? new Set() : new Set(allIds)));
    },
    []
  );

  const clear = useCallback(() => setSelectedIds(new Set()), []);

  return useMemo(
    () => ({
      selectedIds,
      onToggle: toggle,
      onToggleAll: toggleAll,
      clear,
      count: selectedIds.size,
      ids: Array.from(selectedIds),
    }),
    [selectedIds, toggle, toggleAll, clear]
  );
}
